// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dropoffManagement_wrapper__2GRD6","left":"dropoffManagement_left__2y65q","right":"dropoffManagement_right__zMHeI"};